export default __webpack_public_path__ + "static/media/8.18.4c37d368.mp3";